import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import RowInfo from './RowInfo'
import RowDetails from './RowDetails'
import VestsArea from './VestsArea'
import EmployeeService from '../../../services/Employee.service'
import UnvestedAwardDetailsDialog from '../UnvestedAwardDetailsDialog'
import VestedAwardDetailsDialog from "./VestedAwardDetailsDialog"

class CalendarRow extends Component {

  constructor(props) {
    super(props);
    if(props.isCustom) {
      this.state = {
        expanded: true,
        unvestDialogVisible: false,
        vestedDialogVisible: false
      };
    } else {
      this.state = {
        expanded: false,
        unvestDialogVisible: false,
        vestedDialogVisible: false
      };
    }

  }

  onSelectMenuItem = (key) => {
    this.props.onSelectCalendarMenuItem(key, this.props.year)
  }

  onToggle = () =>{
    this.setState({ expanded: !this.state.expanded });
  }

  onTransactionClicked = (transaction) => {
      var award = EmployeeService.loadAward(this.props.awards, transaction.award_id)
      this.setState(
          {
              vestedDialogVisible: true,
              award: award,
              transaction: transaction,
              brokers: EmployeeService.getBrokers(this.props.t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)
          }
      )
  }

  onVestClicked = (vest) => {
    if(!vest.vested) {
        var award = EmployeeService.loadAward(this.props.awards, vest.award_id)
        this.setState(
            {
                unvestDialogVisible: true,
                award: award,
                vest: vest,
                brokers: EmployeeService.getBrokers(this.props.t, award.tax_broker.name, award.net_broker.name, award.mobile_tax_sale_in)
            }
        )
    }
}

  getMenuOptions = (t) => {
    var options = []
    options.push({value: 1, label: t('StockAwards.CalendarSection.CalendarVestMenu.ViewVestsPdfOption')}) 
    options.push({value: 2, label: t('StockAwards.CalendarSection.CalendarVestMenu.DownloadVestsExcelOption')}) 
    options.push({value: 3, label: t('StockAwards.CalendarSection.CalendarVestMenu.ViewDetailedPdfOption')}) 
    options.push({value: 4, label: t('StockAwards.CalendarSection.CalendarVestMenu.DownloadDetailedExcelOption')}) 
    options.push({value: 6, label: t('StockAwards.CalendarSection.CalendarVestMenu.ViewStatementOption')}) 

    if (this.props.fractional_mode){
      options.push({value: 7, label: t('StockAwards.CalendarSection.CalendarVestMenu.VestElection')})
    }

    if(!this.props.fractional_mode && this.props.remainingVests && this.props.remainingVests.length > 0) {
      options.push({value: 5, label: t('StockAwards.CalendarSection.CalendarVestMenu.TaxElections')})
    }

    if(this.props.fractional_mode && this.props.remainingVests && this.props.remainingVests.length > 0) {
      options.push({value: 8, label: t('StockAwards.CalendarSection.CalendarVestMenu.USFedRate')})
    }

    return options
  }

  render() {

    const { t, remainingVests, completedVests, isCustom } = this.props
    const menuOptions = this.getMenuOptions(t)

    return (
        <section aria-label={this.props.title}>
            {!isCustom &&
              <RowInfo
                rowId={this.props.rowId}
                title={this.props.title}
                text={this.props.subTitle}
                menuOptions={menuOptions}
                onSelectMenuItem={this.onSelectMenuItem}
                onToggle={this.onToggle}>
              </RowInfo>
            }

            <RowDetails rowId={this.props.rowId} className="calendar-row-detail">
              {completedVests && completedVests.length > 0 &&
                <VestsArea
                  employee={this.state.employee}
                  areaId={`${this.props.rowId}_completed_vests`}
                  title={t('StockAwards.CalendarSection.CompletedVestsTitle')}
                  transactions={completedVests}
                  isRSU={true}
                  onVestClicked={this.onTransactionClicked}
                  awards={this.props.awards}
                />
              }
              {remainingVests && remainingVests.length > 0 &&
                <VestsArea
                  employee={this.state.employee}
                  areaId={`${this.props.rowId}_remaining_vests`}
                  title={t('StockAwards.CalendarSection.RemainingVestsTitle')}
                  vests={remainingVests}
                  isRSU={true}
                  onVestClicked={this.onVestClicked}
                  awards={this.props.awards}
                />
              }
            </RowDetails>

            <UnvestedAwardDetailsDialog
                employee={this.state.employee}
                visible={this.state.unvestDialogVisible}
                award={this.state.award}
                vest={this.state.vest}
                broker={this.state.award ? this.state.award.tax_broker : null}
                brokers={this.state.brokers}
                done={() => this.setState({unvestDialogVisible: false})}
                onChangePaymentMethod={this.props.onChangePaymentMethod}
            />

            <VestedAwardDetailsDialog
                visible = {this.state.vestedDialogVisible}
                onCloseDialog = {() => this.setState({vestedDialogVisible: false})}
                award={this.state.award}
                brokers={this.state.brokers}
                transaction={this.state.transaction}
            />

        </section>
    )
  }
}

const mapState = state => ({
  awards: state.employee.awards,
  allBrokers: state.brokers,
  fractional_mode: state.static_content.fractional_mode
});

export default connect(mapState)(withTranslation("translations")(CalendarRow))
